<template>
  <div class="waitlist-notify">
    <error-list v-if="errorObject" :error-object="errorObject"/>
    <button v-if="notify == 0 && submitted == 0" type="button" class="btn btn-text" @click.stop.prevent="notifyMe">Notify me when available</button>
    <div v-if="notify == 1 && submitted == 0" class="form-group" :class="{ 'has-error': $v.email.$error }">
      <div class="input-group input-group-sm">
        <input type="email" class="form-control" placeholder="Email Address" v-model.trim="email" @keyup.enter.stop.prevent="submit">
        <span class="input-group-btn">
          <button class="btn btn-default" type="button" @click.stop.prevent="submit">Go!</button>
        </span>
      </div>
      <span v-show="$v.email.$error" class="help-block">Please enter a valid email.</span>
    </div>
    <div v-if="submitted == 1">Processing...</div>
    <div v-if="submitted == 2" class="alert alert-success">Ok!  We'll let you know.</div>
  </div>
</template>

<style scoped>
.form-group {
  margin-bottom: 0;
}
</style>

<script>
import { required, email } from 'vuelidate/lib/validators'
import { ErrorListMixin } from './../mixins/ErrorListMixin'
import ErrorList from "./ErrorList"

export default {
    components: {
        'error-list': ErrorList,
    },

    mixins: [ErrorListMixin],

    props: {
        initialEmail: {
            type: String,
            default: null
        },
        prodID: {
            type: Number,
            default: null,
        },
        colorcode: {
            type: String,
            default: null,
        },
        stylesize: {
            type: String,
            default: null,
        }
    },

    data () {
        return {
            notify: 0,
            email: this.initialEmail,
        }
    },

    validations: {
        email: {
            required,
            email
        }
    },

    methods: {
        prepSubmission: function () {
            this.$v.$reset()
            this.prepErrorList()
        },

        notifyMe: function () {
            if (this.email) {
                // Try submit with initial email
                this.submit()
            } else {
                this.notify = 1
            }
        },

        submit: async function () {
            this.$v.$touch()
            if (!this.$v.$error) {
                const self = this
                this.postAndErrorCheck(
                    '/cart/waitlist',
                    {
                        prodID: this.prodID,
                        colorcode: this.colorcode,
                        stylesize: this.stylesize,
                        email: this.email
                    },
                    null,
                    this.prepSubmission
                )
            }

            this.notify = 1
        },
    }
}
</script>
